import React, { useEffect, useState } from "react";
import {
  getMyRewardsMetaMask,
  getMyWalletMetaMask,
  getMyRewardsWalletConnect,
  getMyWalletWalletConnect,
  getMyRewardsBscWallet,
  getMyWalletBscWallet,
  getMyDateMetaMask,
} from "../services/UserStatsFunctions";

const UserStats = ({ addr, contract }) => {
  //const [totalHatchedPerBIRB, setTotalHatchedPerBIRB] = useState(null);
  //const [nestSize, setNestSize] = useState(null);
  const [myDateMetaMask, setMyDateMetaMask] = useState(null);
  const [myRewardsMetaMask, setMyRewardsMetaMask] = useState(null);
  const [myWalletMetaMask, setMyWalletMetaMask] = useState(null);
  const [myRewardsWalletConnect, setMyRewardsWalletConnect] = useState(null);
  const [myWalletWalletConnect, setMyWalletWalletConnect] = useState(null);
  const [myRewardsBscWallet, setMyRewardsBscWallet] = useState(null);
  const [myWalletBscWallet, setMyWalletBscWallet] = useState(null);

  // useEffect(() => {
  //   getTotalHatched(setTotalHatchedPerBIRB);
  //   getNestSize(setNestSize);
  // }, []);
  const checkChangeWalletHeader = localStorage.getItem("wallet-header");
  useEffect(() => {
    if (localStorage.getItem("wallet-header") === "metamask") {
      getMyDateMetaMask(setMyDateMetaMask, addr);
      getMyRewardsMetaMask(setMyRewardsMetaMask, addr);
      getMyWalletMetaMask(setMyWalletMetaMask, addr);
    } else if (localStorage.getItem("wallet-header") === "binance") {
      getMyRewardsBscWallet(setMyRewardsBscWallet, addr);
      getMyWalletBscWallet(setMyWalletBscWallet, addr);
    } else if (localStorage.getItem("walletconnect")) {
      getMyRewardsWalletConnect(setMyRewardsWalletConnect, addr, contract);
      getMyWalletWalletConnect(setMyWalletWalletConnect, addr, contract);
      return;
    }
  }, [addr, checkChangeWalletHeader, contract]);

  return (
    
    <div className="row">
    <div className="col-12 col-lg-6 col-xl">
        {/* Exit */}
        <div className="card">
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col">
                {/* Title */}
                <h6 className="text-uppercase text-muted mb-2">My Rewards</h6>
                {/* Heading */}
                <span className="h2 mb-0">
                  {addr &&
                    localStorage.getItem("wallet-header") === "metamask" &&
                    myRewardsMetaMask &&
                    myRewardsMetaMask}
                  {addr &&
                    localStorage.getItem("walletconnect") &&
                    myRewardsWalletConnect &&
                    myRewardsWalletConnect}{" "}
                  {addr &&
                    localStorage.getItem("wallet-header") === "binance" &&
                    myRewardsBscWallet &&
                    myRewardsBscWallet}{" "}
                  BNB
                </span>
              </div>
              <div className="col-auto">
                {/* Avatar */}
                <a href="#!" className="avatar avatar-lg">
                  <img
                    src="./img/files/mybnb.png"
                    alt="..."
                    className="avatar-img rounded"
                  />
                </a>
              </div>
            </div>{" "}
            {/* / .row */}
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-6 col-xl">
        {/* Time */}
        <div className="card">
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col">
                {/* Title */}
                <h6 className="text-uppercase text-muted mb-2">My Wallet</h6>
                {/* Heading */}
                <span className="h2 mb-0">
                  {addr &&
                    localStorage.getItem("wallet-header") === "metamask" &&
                    myWalletMetaMask &&
                    myWalletMetaMask}{" "}
                  {addr &&
                    localStorage.getItem("walletconnect") &&
                    myWalletWalletConnect &&
                    myWalletWalletConnect}{" "}
                  {addr &&
                    localStorage.getItem("wallet-header") === "binance" &&
                    myWalletBscWallet &&
                    myWalletBscWallet}{" "}
                  BNBREWARD
                </span>
              </div>
              <div className="col-auto">
                {/* Avatar */}
                <a href="#!" className="avatar avatar-lg">
                  <img
                    src="./img/files/bnbreward.png"
                    alt="..."
                    className="avatar-img rounded"
                  />
                </a>
              </div>
            </div>{" "}
            {/* / .row */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserStats;
